
(function() {
  // Only run on gallery page
  if (!document.querySelector('.re-gallery-grid')) return;

  // Create lightbox overlay
  var overlay = document.createElement('div');
  overlay.className = 're-lightbox';
  overlay.id = 'reLightbox';
  overlay.innerHTML = '<button class="re-lightbox-close" id="reLbClose">&times;</button>' +
    '<button class="re-lightbox-nav re-lightbox-prev" id="reLbPrev">&#8249;</button>' +
    '<img class="re-lightbox-img" id="reLightboxImg" src="" alt="">' +
    '<button class="re-lightbox-nav re-lightbox-next" id="reLbNext">&#8250;</button>' +
    '<div class="re-lightbox-counter" id="reLightboxCounter"></div>';
  document.body.appendChild(overlay);

  // Collect all gallery image URLs
  var galleryItems = document.querySelectorAll('.re-gallery-item img');
  var images = [];
  galleryItems.forEach(function(img) {
    images.push(img.src);
  });

  var currentIndex = 0;
  var lightbox = document.getElementById('reLightbox');
  var lbImg = document.getElementById('reLightboxImg');
  var lbCounter = document.getElementById('reLightboxCounter');

  function openLightbox(index) {
    currentIndex = index;
    showImage();
    lightbox.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    lightbox.classList.remove('active');
    document.body.style.overflow = '';
  }

  function navLightbox(direction) {
    currentIndex += direction;
    if (currentIndex < 0) currentIndex = images.length - 1;
    if (currentIndex >= images.length) currentIndex = 0;
    showImage();
  }

  function showImage() {
    lbImg.classList.remove('loaded');
    lbImg.src = images[currentIndex];
    lbImg.onload = function() {
      lbImg.classList.add('loaded');
    };
    lbCounter.textContent = (currentIndex + 1) + ' / ' + images.length;
  }

  // Attach click handlers to gallery items
  var items = document.querySelectorAll('.re-gallery-item');
  items.forEach(function(item, index) {
    item.style.cursor = 'pointer';
    item.addEventListener('click', function() {
      openLightbox(index);
    });
  });

  // Close button
  document.getElementById('reLbClose').addEventListener('click', function(e) {
    e.stopPropagation();
    closeLightbox();
  });

  // Nav buttons
  document.getElementById('reLbPrev').addEventListener('click', function(e) {
    e.stopPropagation();
    navLightbox(-1);
  });
  document.getElementById('reLbNext').addEventListener('click', function(e) {
    e.stopPropagation();
    navLightbox(1);
  });

  // Click outside image to close
  lightbox.addEventListener('click', function(e) {
    if (e.target === lightbox) closeLightbox();
  });

  // Keyboard navigation
  document.addEventListener('keydown', function(e) {
    if (!lightbox.classList.contains('active')) return;
    if (e.key === 'Escape' || e.key === 'Esc') closeLightbox();
    if (e.key === 'ArrowLeft') navLightbox(-1);
    if (e.key === 'ArrowRight') navLightbox(1);
  });

  // Swipe support for mobile
  var touchStartX = 0;
  lightbox.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });
  lightbox.addEventListener('touchend', function(e) {
    var touchEndX = e.changedTouches[0].screenX;
    var diff = touchStartX - touchEndX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) navLightbox(1);
      else navLightbox(-1);
    }
  }, { passive: true });
})();
